import React from 'react';
import { submit } from '../../../AppServices';
import { FormHoc } from '../../../app-components';
import {
  validateAdminMobile,
  validateEmail,
  validatePassword,
} from '../../../Lib/helpers';
import { MODELS, ROUTES } from '../../../Lib/constants';
import ContactUs from '../../../ContactUs';

const validations = {
  email: ({ data }) => validateEmail(data?.email),
  phonenumber: ({ data }) => validateAdminMobile(data?.phonenumber),
  password: ({ data }) => validatePassword(data.password),
  // eslint-disable-next-line consistent-return
  confirm_password: ({ data }) => {
    if (data.confirm_password !== data.password) {
      return 'Password and confirm password should match.';
    }
  },
};

// const AddAdminForm = FormHoc({
//   type: 'standard',
//   closeView: 1,
//   reloadEvent: ROUTES.adminData.name,
//   onSubmit: submit({ model: MODELS.Admin }),
//   validations,
//   mandatory: {
//     username: 1,
//     email: 1,
//     phonenumber: 1,
//     password: 1,
//     confirm_password: 1,
//     name: 1,
//   },
//   submitMessage: 'Admin has been added successfully.',
//   uniqueValidationMessage: 'Username or Email already exist.',
//   fieldContainer: 'topLabel',
//   lg: {
//     formGroups: [
//       {
//         columnsPerRow: 2,
//         fieldVariant: 'filled',
//         groups: [
//           {
//             columns: [
//               {
//                 type: 'text',
//                 field: 'name',
//                 label: 'Admin Name',
//                 placeholder: 'Enter Admin Name',
//                 allowWhiteSpaces: true,
//                 mandatory: true,
//               },
//               {
//                 type: 'text',
//                 field: 'username',
//                 label: 'Admin Username',
//                 placeholder: 'Enter Admin Username',
//                 mandatory: true,
//               },
//               {
//                 type: 'text',
//                 field: 'phonenumber',
//                 label: 'Mobile Number',
//                 placeholder: 'Enter Mobile Number',
//                 mandatory: true,
//               },
//               {
//                 type: 'text',
//                 field: 'email',
//                 label: 'Email Id',
//                 placeholder: 'Enter Email Id',
//                 mandatory: true,
//               },
//               {
//                 type: 'password',
//                 field: 'password',
//                 label: 'Password',
//                 placeholder: 'Enter Password',
//                 mandatory: true,
//               },
//               {
//                 type: 'password',
//                 field: 'confirm_password',
//                 label: 'Confirm Password',
//                 placeholder: 'Re-enter Password',
//                 mandatory: true,
//               },
//             ],
//           },
//         ],
//       },
//     ],
//   },
// });


const ContactUsForm = ContactUs()


const AddDealer = (props) => <ContactUsForm />;

export default AddDealer;
